import type { FlowStep } from '@forq/ui';
import { rentalStatusLabels, type RentalOrder, type RentalStatus } from '@forq/rental-data';

const rentalFlowOrder: readonly RentalStatus[] = ['request', 'reserved', 'active', 'return_scheduled', 'completed'];
const rentalRank = new Map<RentalStatus, number>(rentalFlowOrder.map((status, index) => [status, index]));

/** FORQ Flow trail for a rental order (done → current → upcoming, cancelled terminal). */
export function buildRentalFlow(order: RentalOrder): readonly FlowStep[] {
  if (order.status === 'cancelled') {
    return [
      { key: 'request', label: rentalStatusLabels.request, state: 'done' },
      { key: 'cancelled', label: rentalStatusLabels.cancelled, state: 'cancelled' },
    ];
  }
  const currentRank = rentalRank.get(order.status) ?? 0;
  return rentalFlowOrder.map((status) => {
    const rank = rentalRank.get(status) ?? 0;
    return {
      key: status,
      label: rentalStatusLabels[status],
      state: rank < currentRank ? 'done' : rank === currentRank ? 'current' : 'upcoming',
    };
  });
}
